import React from "react"
import { HelmetProvider } from "react-helmet-async"
import App from "./App"
import * as serviceWorker from "./serviceWorker"
import { BrowserRouter } from "react-router-dom"
import { Provider } from "react-redux"
import { QueryClientProvider } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import store from "./store"
import { queryClient } from './utils/queryClient'
import ReactDOM from "react-dom/client";
import { installUpgradeModalFetchInterceptor } from './utils/axiosUpgradeInterceptor'
import './styles/filter-badge.css'
import { configureToastr } from './utils/toast'

installUpgradeModalFetchInterceptor()

// Configure toastr globally so all pages use the same toast format
try { configureToastr() } catch (err) { /* ignore */ }

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    <QueryClientProvider client={queryClient}>
      <HelmetProvider>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </HelmetProvider>
      {process.env.NODE_ENV === 'development' && (
        <ReactQueryDevtools initialIsOpen={false} />
      )}
    </QueryClientProvider>
  </Provider>
)

serviceWorker.unregister()
